import * as React from 'react';
import {memo, useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import ScrollArea from 'react-scrollbar';
import {Accordion, Card, useAccordionButton} from "react-bootstrap";
import {CardHeader, CardBody, Row, Col, Label} from 'reactstrap'
import {getLogs, setLogs, toggleQuickPanel} from './store/logSlice';
import reducer from './store';
import withReducer from "../../store/withReducer";
import CountryList from "../seller/seller-vat/countryList";
import InitialsAvatar from "react-initials-avatar";
import './styles.scss';


// const useStyles = makeStyles(theme => ({
//     root: {
//         width: 350
//     }
// }));
function CustomToggle({children, eventKey}) {
    const [isOpen, setIsOpen] = useState(false);
    const decoratedOnClick = useAccordionButton(eventKey, () =>
        setIsOpen(!isOpen)
    );

    return (
        <button
            type="button"
            className="btn btn-primary-outline pull-right"
            onClick={decoratedOnClick}
        >
            {isOpen ? <i className="fa fa-chevron-circle-up"></i> : <i className="fa fa-chevron-circle-down"></i>}
        </button>
    );
}

function LogActivity(props) {
    const dispatch = useDispatch();
    const state = useSelector(({log}) => log.log);
    const {id=null, log}=props;
    // const classes = useStyles();
    const [expanded, setExpanded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (state.drawer.isOpen) {
            const dataObj = {log: state.drawer.log, subject_id: state.drawer.id};
            dispatch(getLogs(dataObj)).then(res => {
                // eslint-disable-next-line array-callback-return
                res.payload.map(n => {
                    if (n.changes.old) {
                        console.log(n.changes.old.Details);
                    }
                });
                dispatch(setLogs(res.payload));
            });
        }
    }, [dispatch, state.drawer.isOpen]);

    const getObjectKeys = changes => {
        const keys = Object.keys(changes);
        return keys;
    };
    const isSameValue = (oldAttribute, newAttribute) => {
        return oldAttribute === newAttribute;
    };
    const isHasSameValue = (item, attributes, changeItem, nestedIndex) => {
        let unChangedValue = ""
        // eslint-disable-next-line array-callback-return
        attributes.map(n => {
            if (item.changes.old[changeItem][nestedIndex][n] === item.changes.attributes[changeItem][nestedIndex][n]) {
                unChangedValue = {
                    "key": n,
                    "value": item.changes.old[changeItem][nestedIndex][n]
                }
            }

        });
        console.log(unChangedValue);
        return unChangedValue;
    };

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div className={`actitity-log ${props.className ?? ''}`}>
            <div className="float-right">
                <button className="btn btn-default float-right" onClick={() => {
                    // document.querySelector(".customizer-contain").classList.add('open');
                    dispatch(toggleQuickPanel({isOpen:true,id,log}))
                }
                }>
                    <i className="fa fa-clock-o fa-2x"></i>
                </button>
            </div>
            <div className={`customizer-contain ${state.drawer.isOpen ? 'open' : ''}`}>
                <div className="customizer-header">
                    <i 
                        className="icon-close" 
                        onClick={() => {
                            // document.querySelector(".customizer-contain").classList.remove('open');
                            dispatch(toggleQuickPanel({isOpen:false,id:null,log:null}))
                        }} 
                    />

                    <h5>Log Activity</h5>
                    <div style={{height: '1000'}}>
                        <ScrollArea
                            horizontal={false}
                            vertical={true}
                        >
                            <Accordion defaultActiveKey="0">
                                {state.logs.map((item, index) =>

                                    <Card key={index} style={{margin: 0}}>
                                        <Card.Header style={{padding: 10}}>
                                            <Row className="align-items-center">
                                                <Col sm={1} className="pe-0">
                                                    <InitialsAvatar className="log-activity-image" name={item.created_by} />
                                                </Col>
                                                <Col sm={8}>
                                                    <div>
                                                        <Label className="form-label mb-0">{item.description}</Label>
                                                        <div className="text-muted small">{item.created_by} • {item.date}</div>
                                                    </div>
                                                </Col>
                                                <Col sm={3} className="text-end">
                                                    <CustomToggle eventKey={index} />
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={index}>
                                            <Card.Body className="log-changes-body">
                                                {item.changes.old ? (
                                                    <div>
                                                        {getObjectKeys(item.changes.old).map((changeItem, changeIndex) => (
                                                            <div key={changeIndex} className="mb-3">
                                                                <h6 className="log-title m-0 pt-0">{changeItem}</h6>
                                                                {Array.isArray(item.changes.old[changeItem]) ? (
                                                                    item.changes.old[changeItem].map((nestedItem, nestedIndex) => (
                                                                        <div key={nestedIndex} className="ps-3 mb-2">
                                                                            {typeof nestedItem === 'object' ? (
                                                                                <table className="table table-xs table-bordered mb-0">
                                                                                    <tbody>
                                                                                        {getObjectKeys(nestedItem).map(nestedKey => {
                                                                                            const oldVal = item.changes.old[changeItem][nestedIndex][nestedKey];
                                                                                            const newVal = (item.changes.attributes[changeItem] && item.changes.attributes[changeItem][nestedIndex]) ? item.changes.attributes[changeItem][nestedIndex][nestedKey] : undefined;
                                                                                            if (oldVal === newVal) return null; // skip unchanged
                                                                                            return (
                                                                                                <tr key={nestedKey}>
                                                                                                    <td><strong>{nestedKey}</strong></td>
                                                                                                    <td className="text-danger">{oldVal ?? '∅'}</td>
                                                                                                    <td className="text-center">→</td>
                                                                                                    <td className="text-success">{newVal ?? '∅'}</td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}
                                                                                    </tbody>
                                                                                </table>
                                                                            ) : (
                                                                                <div className="row">
                                                                                    <div className="col text-danger">{nestedItem ?? '∅'}</div>
                                                                                    <div className="col text-success">{(item.changes.attributes[changeItem] && item.changes.attributes[changeItem][nestedIndex]) ?? '∅'}</div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div className="ps-3">
                                                                        <div className="row">
                                                                            <div className="col text-danger">{item.changes.old[changeItem] ?? '∅'}</div>
                                                                            <div className="col text-success">{item.changes.attributes[changeItem] ?? '∅'}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : null}
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )}
                            </Accordion>
                        </ScrollArea>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withReducer([{log: reducer}])(memo(LogActivity));
